

import './email-confirmation.component.js';
import './email-confirmation.controller.js';
import './email-confirmation.service.js';
import './_email-confirmation.styles.scss';

angular.module('inkfinder')
.config(function($stateProvider) {
  $stateProvider
  .state('email-confirmation', {
    url: '/email-confirmation?token',
    views: {
      '@': {
        component: 'inkEmailConfirmation'
      }
    },
    resolve: {
      $title: (() => 'Email confirmation'),
      response: function(EmailConfirmation, $stateParams) {
        return EmailConfirmation.get($stateParams.token)
        .then(function(response) {
          return response;
        });
      }
    }
  });
});



// WEBPACK FOOTER //
// ./components/collector/email-confirmation/index.js